// Firestore service for managing work tracking data
import { db } from '../firebase';
import { 
  doc, 
  setDoc, 
  getDoc, 
  updateDoc, 
  onSnapshot 
} from 'firebase/firestore';

// Time slots for the day
export const TIME_SLOTS = [
  '11:00',
  '13:00', 
  '15:00',
  '17:00',
  '19:00',
  '21:00',
  '23:00'
];

// Initialize user data if it doesn't exist
export const initializeUserData = async (userName) => {
  const userDoc = doc(db, 'users', userName);
  const userSnapshot = await getDoc(userDoc);
  
  if (!userSnapshot.exists()) {
    // Create initial user document with empty data
    await setDoc(userDoc, {
      name: userName,
      createdAt: new Date().toISOString()
    });
  }
};

// Get user data for a specific date
export const getUserDataForDate = async (userName, date) => {
  const userDoc = doc(db, 'users', userName, 'dates', date);
  const docSnapshot = await getDoc(userDoc);
  
  if (docSnapshot.exists()) {
    return docSnapshot.data();
  } else {
    // Return default structure if no data exists
    const defaultData = {};
    TIME_SLOTS.forEach(slot => {
      defaultData[slot] = { status: 'none', text: '' };
    });
    return defaultData;
  }
};

// Update a time slot for a specific user and date
export const updateTimeSlot = async (userName, date, timeSlot, status, text = '') => {
  const userDateDoc = doc(db, 'users', userName, 'dates', date);
  
  // Update the specific time slot
  await setDoc(userDateDoc, {
    [timeSlot]: {
      status: status,
      text: text,
      updatedAt: new Date().toISOString()
    }
  }, { merge: true }); // merge: true allows updating only the specific field
};

// Listen to real-time updates for a specific user and date
export const listenToUserData = (userName, date, callback) => {
  const userDateDoc = doc(db, 'users', userName, 'dates', date);
  
  // Set up real-time listener
  const unsubscribe = onSnapshot(userDateDoc, (docSnapshot) => {
    if (docSnapshot.exists()) {
      callback(docSnapshot.data());
    } else {
      // Return default data if document doesn't exist
      const defaultData = {};
      TIME_SLOTS.forEach(slot => {
        defaultData[slot] = { status: 'none', text: '' };
      });
      callback(defaultData);
    }
  });
  
  // Return unsubscribe function to clean up listener
  return unsubscribe;
};

// Get all dates data for a user (for calendar view)
export const getAllUserData = async (userName) => {
  const userDoc = doc(db, 'users', userName);
  // Note: This would require a more complex query to get all date subcollections
  // For now, we'll handle this in the component by querying individual dates
  return {};
};
